import { render, staticRenderFns } from "./ChoiceTangenlist.vue?vue&type=template&id=2c39a94b&scoped=true"
import script from "./ChoiceTangenlist.vue?vue&type=script&lang=js"
export * from "./ChoiceTangenlist.vue?vue&type=script&lang=js"
import style0 from "./ChoiceTangenlist.vue?vue&type=style&index=0&id=2c39a94b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39a94b",
  null
  
)

export default component.exports